import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SabisGrid2Component } from './sabis-grid2/sabis-grid2.component';

import { TableModule } from 'primeng/table';
import { AutoFocusModule } from 'primeng/autofocus';
import { SabisGrid2EditorComponent } from './combo-column/editor/editor.component';
import { DropdownModule } from 'primeng/dropdown';
import { SabisGrid2ComboViewerComponent } from './combo-column/combo-viewer/combo-viewer.component';
import { TextViewerComponent } from './text-column/text-viewer/text-viewer.component';
import { TextEditorComponent } from './text-column/text-editor/text-editor.component';
import { BooleanEditorComponent } from './boolean-column/boolean-editor/boolean-editor.component';
import { BooleanViewerComponent } from './boolean-column/boolean-viewer/boolean-viewer.component';
import { SabisComponents2Module } from 'sabis-components2';
import { NumberEditorComponent } from './number-column/number-editor/number-editor.component';
import { NumberViewerComponent } from './number-column/number-viewer/number-viewer.component';
import { DateViewerComponent } from './date-column/date-viewer/date-viewer.component';
import { DateEditorComponent } from './date-column/date-editor/date-editor.component';
import { MultiSelectModule } from 'primeng/multiselect';

@NgModule({
  declarations: [
    SabisGrid2Component,
    SabisGrid2EditorComponent,
    SabisGrid2ComboViewerComponent,
    TextViewerComponent,
    TextEditorComponent,
    NumberEditorComponent,
    NumberViewerComponent,
    BooleanEditorComponent,
    BooleanViewerComponent,
    DateViewerComponent,
    DateEditorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    //BrowserAnimationsModule,
    TableModule,
    AutoFocusModule,
    DropdownModule,
    SabisComponents2Module,
    MultiSelectModule,
  ],
  exports: [
    SabisGrid2Component
  ]
})
export class SabisGrid2Module { }
